import React from "react";
import {
  Box,
  Card,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Stack,
  Typography,
} from "@mui/material";
import { formatPassExpiry } from "../utils/formatters";

const PassSelector = ({ passes, selectedPass, onPassChange }) => {
  return (
    <FormControl component="fieldset" sx={{ width: "100%" }}>
      <FormLabel component="legend" sx={{ mb: 1.5, fontWeight: 600 }}>
        🎫 Wybierz Karnet
      </FormLabel>
      <RadioGroup
        name="passes"
        value={selectedPass || ""}
        onChange={(e) => onPassChange(e.target.value)}
      >
        <Stack spacing={1}>
          {passes.map((p) => {
            const exp = formatPassExpiry(p.valid_until);
            
            const hasUnlimitedLessons = p.lesson_categories_for_pass
              ? p.lesson_categories_for_pass.some(category => category.is_unlimited)
              : false;

            const totalRemainingLessons = p.lesson_categories_for_pass
              ? p.lesson_categories_for_pass.reduce((sum, category) => sum + category.remaining_lessons, 0)
              : 0;

            return (
              <Card 
                key={p.id} 
                elevation={0}
                sx={{ 
                  border: selectedPass === p.id ? '2px solid #2196f3' : '1px solid #e0e0e0',
                  backgroundColor: selectedPass === p.id ? '#e3f2fd' : 'transparent',
                  transition: 'all 0.2s',
                  '&:hover': {
                    borderColor: '#2196f3',
                  }
                }}
              >
                <FormControlLabel
                  value={p.id}
                  control={<Radio />}
                  label={
                    <Box sx={{ py: 0.5 }}>
                      <Typography variant="body2" fontWeight="600">
                        {hasUnlimitedLessons ? "🔓 Bez limitu" : `${totalRemainingLessons} zajęć`}
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        Ważny do: {exp}
                      </Typography>
                    </Box>
                  }
                  sx={{ 
                    m: 0, 
                    p: 1.5, 
                    width: '100%',
                    '& .MuiFormControlLabel-label': {
                      width: '100%'
                    }
                  }}
                />
              </Card>
            );
          })}
        </Stack>
      </RadioGroup>
    </FormControl>
  );
};

export default PassSelector;
